import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {UPDATE_GROWTH_PATH_ERROR, UPDATE_GROWTH_PATH_START, UPDATE_GROWTH_PATH_SUCCESS} from "../../types";

export function* update({payload}) {
    try {
        const url = `/growthpath/${payload.formData.id}/`;
        const method = 'PUT';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
        const data = (object) => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        const results = yield call(apiCall, url, method, data(payload.formData), headers);
        yield put({type: UPDATE_GROWTH_PATH_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-growth-path'));
    } catch (error) {
        yield put({type: UPDATE_GROWTH_PATH_ERROR, error});
    }
}

export default function* update_growth_path() {
    yield takeLatest(UPDATE_GROWTH_PATH_START, update);
}